import { ListLiteProps } from "@app/shared/metrics/MetricsListLite";
import { QesColors } from "@app/shared/qes-standards/colors";

export const mockListData: ListLiteProps = {
  items: [
    {
      color: QesColors.QesPrimaryGray5,
      label: "No status",
      value: 562,
    },
    {
      color: QesColors.QesPrimaryGray8,
      label: "High risk",
      value: 242,
    },
    {
      color: QesColors.QesTertiaryBlue1,
      label: "IP - Research",
      value: 194,
    },
    {
      color: QesColors.QesTertiaryYellow2,
      label: "IP - Contract",
      value: 148,
    },
    {
      color: QesColors.QesPrimaryRed,
      label: "Exc. Required",
      value: 124,
    },
    {
      color: QesColors.QesTertiaryGreen2,
      label: "IP - Gap Filled",
      value: 112,
    },
    {
      color: QesColors.QesTertiaryPurple1,
      label: "Exc. RPPO",
      value: 100,
    },
  ],
}